import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import {
    Reflection,
    ReflectionDto,
    ReflectionParams,
    ReflectionParamsDto,
    ReflectionSubmitResponse,
    ReflectionSubmitResponseDto,
    ReflectionValue,
    ReflectionValueDto,
} from '../models';

@Injectable({
    providedIn: 'root',
})
export class ReflectionHttpService {
    private readonly httpClient = inject(HttpClient);

    getReflection(id: string, params: ReflectionParams = {}): Observable<Reflection> {
        return this.httpClient
            .get<ReflectionDto>(`library/reflections/${id}/response`, { params: new ReflectionParamsDto(params).params })
            .pipe(mapDto((dto) => new Reflection(dto)));
    }

    submitReflection(id: string, value: ReflectionValue): Observable<ReflectionSubmitResponse> {
        return this.httpClient
            .post<ReflectionSubmitResponseDto>(`library/reflections/${id}/response`, new ReflectionValueDto(value))
            .pipe(mapDto((dto) => new ReflectionSubmitResponse(dto)));
    }
}
